<ul
  [hidden]="!isOpen"
  class="dropdown-menu"
  role="listbox"
  [attr.aria-labelledby]="triggerId"
>
  <app-form-dropdown-item
    *ngFor="let option of options"
    [option]="option"
    (click)="setSelected(option)"
    (keydown.enter)="setSelected(option)"
    (keydown.space)="setSelected(option)"
  ></app-form-dropdown-item>
</ul>
